import React, { PureComponent, Fragment } from "react";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  ReferenceLine,
} from "recharts";

import {
  Metric,
  selectFormat,
  selectIcon,
  Error,
  StandardTooltip,
} from "./../../../Utils/Utils.js";

import Heading from "./../../../Elements/Heading";

class SocialFollowersSubscribers extends PureComponent {
  renderNetworks = (data) => (
    <Fragment>
      {data.facebook !== undefined && data.facebook > 0 && (
        <div className="d-flex flex-direction-row mt-2" key={"facebook"}>
          <img
            src={selectIcon("facebook")}
            alt={"facebook"}
            width="20"
            height="20"
          />{" "}
          &nbsp; &nbsp;
          <Metric value={data.facebook} size={"sm"} />
        </div>
      )}

      {data.instagram !== undefined && data.instagram > 0 && (
        <div className="d-flex flex-direction-row mt-2" key={"instagram"}>
          <img
            src={selectIcon("instagram")}
            alt={"instagram"}
            width="20"
            height="20"
          />{" "}
          &nbsp; &nbsp;
          <Metric value={data.instagram} size={"sm"} />
        </div>
      )}

      {data.youtube !== undefined && data.youtube > 0 && (
        <div className="d-flex flex-direction-row mt-2" key={"youtube"}>
          <img
            src={selectIcon("youtube")}
            alt={"youtube"}
            width="20"
            height="20"
          />{" "}
          &nbsp; &nbsp;
          <Metric value={data.youtube} size={"sm"} />
        </div>
      )}

      {data.twitter !== undefined && data.twitter > 0 && (
        <div className="d-flex flex-direction-row mt-2" key={"twitter"}>
          <img src={selectIcon("twitter")} alt={"twitter"} /> &nbsp; &nbsp;
          <Metric value={data.twitter} size={"sm"} />
        </div>
      )}
    </Fragment>
  );

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row">
        <div className="col-8">
          <Heading size={6}>New Subscribers</Heading>
          <Metric {...data.total} size={"lg"} />

          <ResponsiveContainer height={300} width="100%">
            <BarChart data={data.graph}>
              <Tooltip
                cursor={{ fill: "#eee", opacity: 0.5 }}
                content={
                  <StandardTooltip
                    render={({ data }) => {
                      const payload = data(this.props);
                      if (payload !== null) {
                        return (
                          <div className="standard-tooltip">
                            {Object.keys(payload).map((key) => (
                              <Fragment key={key}>
                                <header className="standard-tooltip__header">
                                  <span className="standard-tooltip__key-header">
                                    Date:
                                  </span>
                                  <span className="standard-tooltip__value-header">
                                    {payload[key].payload.date}
                                  </span>
                                </header>

                                <main className="standard-tooltip__main">
                                  <div
                                    className="standard-tooltip__item"
                                    key={key}
                                  >
                                    <span className="standard-tooltip__key">
                                      <span
                                        className="standard-tooltip__icon"
                                        style={{ background: "#FA6E57" }}
                                      />
                                      {payload[key].payload.date}
                                    </span>
                                    <span className="standard-tooltip__value">
                                      {selectFormat(
                                        "number",
                                        payload[key].value
                                      )}
                                    </span>
                                  </div>
                                </main>
                              </Fragment>
                            ))}
                          </div>
                        );
                      }
                    }}
                  />
                }
              />

              <defs>
                <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#FAA461" stopOpacity={1} />
                  <stop offset="95%" stopColor="#FC6D52" stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar dataKey="value" fillOpacity={1} fill="url(#colorUv)" />
              <XAxis dataKey="date" hide />
              <ReferenceLine
                y={0}
                strokeDasharray="3 3"
                stroke="#FC6D52"
                ifOverflow="extendDomain"
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="col-4">{this.renderNetworks(data)}</div>
      </div>
    );
  }
}

export default SocialFollowersSubscribers;
